import { getLocationSettings } from '../api/location-settings-api'

export const shouldWarnAboutRetainedLocationSettingsOverride = (
    devices,
    locationSettings
) =>
    Boolean(locationSettings?.data?.bait_settings) &&
    devices.some(device => device.override_location_settings)

export async function shouldWarnAboutRetainedLocationSettingsOverrideForMoves(
    moves
) {
    const movesWithExceptions = moves.filter(move =>
        move.devices.some(device => device.override_location_settings)
    )
    const destinationSettings = await Promise.all(
        movesWithExceptions.map(move => getLocationSettings(move.locationId))
    )

    return movesWithExceptions.some((move, index) =>
        shouldWarnAboutRetainedLocationSettingsOverride(
            move.devices,
            destinationSettings[index]
        )
    )
}
